import { MAX_INPUT_LENGTH } from "@finway-group/shared/lib/utils/validators"
import { Form, Input, Modal } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { ExpenseRules } from "Components/forms/rules"
import { CancelableComponent, ModalComponentPropsBase } from "Shared/context/modal.context"

interface RejectModalInterface extends CancelableComponent, ModalComponentPropsBase {
    title: string
    message: string
    okText: string
    cancelText: string
    onSubmit: (values: RejectModalFormValues) => Promise<void>
}

export interface RejectModalFormValues {
    reasonToReject: string
}

export const RejectModal = ({ isShowing, title, message, okText, cancelText, onSubmit, onCancel }: RejectModalInterface) => {
    const [form] = Form.useForm<RejectModalFormValues>()
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const { reasonToReject: reasonToRejectRules } = ExpenseRules({})

    const handleHide = () => {
        setIsLoading(false)
        form.resetFields()
        onCancel?.()
    }
    const onFormSubmit = async (values: RejectModalFormValues) => {
        setIsLoading(true)
        await onSubmit(values)
        handleHide()
    }

    return (
        <Modal
            title={title}
            open={isShowing}
            maskClosable={false}
            onOk={form.submit}
            onCancel={handleHide}
            okText={okText}
            cancelText={cancelText}
            keyboard
            destroyOnClose
            closable={true}
            confirmLoading={isLoading}
        >
            <Form form={form} layout="vertical" onFinish={onFormSubmit}>
                <Form.Item name="reasonToReject" key="reasonToReject" label={message} required rules={reasonToRejectRules}>
                    <Input placeholder={t("placeholder:request.reject")} maxLength={MAX_INPUT_LENGTH} />
                </Form.Item>
            </Form>
        </Modal>
    )
}
